import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    handleClose();
  };

  const isRTL = i18n.language === 'ar';

  return (
    <Box sx={{
      position: 'fixed',
      bottom: 24,
      right: isRTL ? 'auto' : 24,
      left: isRTL ? 24 : 'auto',
      zIndex: 1000
    }}>
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: 'white',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          padding: '10px',
          '&:hover': { backgroundColor: '#f5f5f5', transform: 'translateY(-2px)' },
          transition: 'all 0.2s ease'
        }}
      >
        <LanguageIcon sx={{ fontSize: 22 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
        <MenuItem onClick={() => changeLanguage('ar')}>العربية</MenuItem>
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
